import React from "react";
import { Modal } from "@instructure/ui-modal";
import { Heading } from "@instructure/ui-heading";
import { Alert } from "@instructure/ui-alerts";
import { Button } from "@instructure/ui-buttons";
import { View } from "@instructure/ui-view";
import { Flex } from "@instructure/ui-flex";
import { Billboard } from "@instructure/ui-billboard";
import { Grid } from "@instructure/ui-grid";
import { IconCompleteLine, IconAddLine } from "@instructure/ui-icons";
import { Text } from "@instructure/ui-text";
import { Pill } from "@instructure/ui-pill";
import { useStateValue } from "../../context-store/AppStateProvider";
import { ACTIONS } from "../../context-store/ACTIONS";
import FormatDateUtil, { dateInputFormat } from "../../utils/formatDate";

const IasCreatedCourseModal = () => {
  const [
    { isCreatedCourseModalOpen, createdCourse },
    dispatch,
  ] = useStateValue();

  const closeModal = () => {
    dispatch({
      type: ACTIONS.BACK_TO_FORM,
    });
  };

  return (
    <Modal
      as="main"
      variant={"default"}
      insertAt={"bottom"}
      role="alert"
      open={isCreatedCourseModalOpen}
      onDismiss={closeModal}
      size="fullscreen"
      label={createdCourse.title}
      shouldCloseOnDocumentClick={false}
    >
      <Modal.Header>
        <Heading>{createdCourse.title}</Heading>
      </Modal.Header>
      <Modal.Body>
        <View>
          <Alert
            margin="small"
            transition="none"
            variant={createdCourse.error ? "error" : "info"}
          >
            {createdCourse.message}
          </Alert>
        </View>
        <View>
          <Grid colSpacing="small" rowSpacing="small">
            {/* //** Curriculum Date */}
            <Grid.Row>
              <Grid.Col width={{ small: 4, medium: 4, large: 4, xLarge: 4 }}>
                <Pill margin="x-small">
                  <Text>Curriculum</Text>
                </Pill>
              </Grid.Col>
              <Grid.Col width={{ small: 8, medium: 8, large: 8, xLarge: 8 }}>
                <Text>{createdCourse.curriculum}</Text>
              </Grid.Col>
            </Grid.Row>
            {/* //** Start Date */}
            <Grid.Row>
              <Grid.Col width={{ small: 4, medium: 4, large: 4, xLarge: 4 }}>
                <Pill margin="x-small">
                  <Text>Start Date</Text>
                </Pill>
              </Grid.Col>
              <Grid.Col width={{ small: 8, medium: 8, large: 8, xLarge: 8 }}>
                <Text lineHeight="double">
                  {FormatDateUtil.formatUtcToLocal(
                    createdCourse.startDate,
                    dateInputFormat
                  )}
                </Text>
              </Grid.Col>
            </Grid.Row>
            {/* //** End Date */}
            <Grid.Row>
              <Grid.Col width={{ small: 4, medium: 4, large: 4, xLarge: 4 }}>
                <Pill margin="x-small">
                  <Text>End Date</Text>
                </Pill>
              </Grid.Col>
              <Grid.Col width={{ small: 8, medium: 8, large: 8, xLarge: 8 }}>
                <Text lineHeight="double">
                  {FormatDateUtil.formatUtcToLocal(
                    createdCourse.endDate,
                    dateInputFormat
                  )}
                </Text>
              </Grid.Col>
            </Grid.Row>
            {/* //** Langauge */}
            <Grid.Row>
              <Grid.Col width={{ small: 4, medium: 4, large: 4, xLarge: 4 }}>
                <Pill margin="x-small">
                  <Text>Language</Text>
                </Pill>
              </Grid.Col>
              <Grid.Col width={{ small: 8, medium: 8, large: 8, xLarge: 8 }}>
                <Text lineHeight="double">{createdCourse.language}</Text>
              </Grid.Col>
            </Grid.Row>
            {/* //** Delivery Modality */}
            <Grid.Row>
              <Grid.Col width={{ small: 4, medium: 4, large: 4, xLarge: 4 }}>
                <Pill margin="x-small">
                  <Text>Delivery Modality</Text>
                </Pill>
              </Grid.Col>
              <Grid.Col width={{ small: 8, medium: 8, large: 8, xLarge: 8 }}>
                <Text lineHeight="double">
                  {createdCourse.deliveryModality}
                </Text>
              </Grid.Col>
            </Grid.Row>
          </Grid>
        </View>

        <View as="div" width="500px" margin="auto">
          <Flex justifyItems="center">
            <Flex.Item>
              <Billboard
                margin="large"
                heading="Add"
                color="success"
                message="Add another course"
                onClick={closeModal}
                hero={() => <IconAddLine size={"medium"} />}
              />
            </Flex.Item>
          </Flex>
        </View>
      </Modal.Body>
      <Modal.Footer>
        <Button
          color="primary"
          type="button"
          renderIcon={IconCompleteLine}
          onClick={closeModal}
        >
          Done
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default IasCreatedCourseModal;
